// src/services/api.js
import axios from 'axios';

console.log('🔧 API SERVICE INITIALIZING');
console.log('📌 REACT_APP_API_URL env var:', process.env.REACT_APP_API_URL);
console.log('📌 NODE_ENV:', process.env.NODE_ENV);

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000',
});

console.log('✅ API Created with baseURL:', API.defaults.baseURL);

// Automatically add Authorization header if token exists
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => Promise.reject(error));

// Handle 401 responses
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const token = localStorage.getItem('token');
      const requestUrl = error.config?.url || '';
      const isAuthRoute = ['/login', '/signup', '/verify', '/verify-email', '/resend-otp', '/forgot-password', '/reset-password', '/verify-2fa']
        .some((path) => requestUrl.includes(path));

      // Only force-redirect if we actually had a token and it's not an auth-flow call
      if (token && !isAuthRoute) {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default API;
